import { useBulkActionContext } from '@user/components/xGrid'
import { ENTITY_TYPES } from '@sales-center/common'
import { useSelector } from 'react-redux'
import { selectAllLeads } from '@user/store/lead'
import { selectAllOpportunities } from '@user/store/opportunity'
import {
  OwnerMenuItem,
  useGetOwnerList,
} from '@user/store/salesTeam/hooks/useGetOwnerList'

type Props = {
  entityType: ENTITY_TYPES
}

export function useData(props: Props) {
  const { selectedRows } = useBulkActionContext()
  const allLeads = useSelector(selectAllLeads)
  const allOpportunities = useSelector(selectAllOpportunities)

  const entity =
    props.entityType === ENTITY_TYPES.Lead
      ? allLeads.find((lead) => lead.id === selectedRows[0])
      : allOpportunities.find(
          (opportunity) => opportunity.id === selectedRows[0],
        )

  const ownerList: OwnerMenuItem[] = useGetOwnerList(
    ENTITY_TYPES.Lead,
    entity?.salesTeamId || -1,
    false,
  )

  if (selectedRows.length === 1) {
    const filteredOwners = ownerList.map((user) => ({
      id: user.id,
      fullName: user.name,
      isPosition: user.isPosition,
      level: user.level,
    }))

    const salesTeamUsers = [
      {
        id: null,
        fullName: 'Unassigned',
        isPosition: false,
        level: 0,
      },
      ...filteredOwners,
    ]

    return {
      initialValues: {
        expectedClosingDate: new Date(),
        owner:
          entity?.assignee === null
            ? salesTeamUsers[0]
            : salesTeamUsers.find((user) => user.id === entity?.assignee?.id) ||
              null,
      },
      owners: salesTeamUsers,
      selectedRowCount: selectedRows.length || 0,
    }
  }

  return {
    owners: [],
    initialValues: {
      expectedClosingDate: new Date(),
      owner: null,
    },
    selectedRowCount: selectedRows.length || 0,
  }
}
